module.exports = __webpack_public_path__ + "static/media/ORISHA_LOGOTYPE_GROUPE_EXECUTE_NEGATIF_RVB.26c1dcbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/ORISHA_LOGOTYPE_GROUPE_EXECUTE_NEGATIF_RVB.svg
// module id = 1011
// module chunks = 0